import { TActions } from '../../../AppModulesWrapper';
import { RESET_STATE } from '../../actions/resetState';

import { IPublishAvailableState } from '../../types/reducers/publishAvailable';

export const defaultState: IPublishAvailableState = {
  isIdentificationNeeded: false,
  isPublishToHiddenBase: false,
};

export function publishAvailable(
  state: IPublishAvailableState = defaultState,
  action: TActions,
): IPublishAvailableState {
  switch (action.type) {
    case RESET_STATE:
      return {
        ...defaultState,
      };

    default:
      return state;
  }
}
